export default [{
  path: '/attendance_report_new',
  name: 'attendance_report_new',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/AttendanceReportNew/index')
}]

